<template>
    <div class="inner-wrapper">
        <div class="row newcountbox" v-if="allData">
            <div class="col">
                <div class="card bg-soft-secondary">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-secondary">{{allData.orderData.total_todo}}</h1>
                        <div class="fw-medium">Total To-Do</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-dark">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-dark">{{allData.orderData.total_reminder}}</h1>
                        <div class="fw-medium">Reminders</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-success">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-success">{{allData.orderData.order_open}}</h1>
                        <div class="fw-medium">Open Orders</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-info">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-info">{{allData.orderData.order_sent_customer}}</h1>
                        <div class="fw-medium">Sent to Customer</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-primary">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-primary">{{allData.orderData.order_artwork_approval}}</h1>
                        <div class="fw-medium">Artwork Approval</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-danger">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-danger">{{allData.orderData.order_in_production}}</h1>
                        <div class="fw-medium">In Production</div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card bg-soft-warning">
                    <div class="card-body text-center">
                        <i class=""></i>
                        <h1 class="fw-semibold mb-0 text-warning">{{allData.orderData.order_shipped}}</h1>
                        <div class="fw-medium">Shipped</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row customrow2">
            <div class="col-lg-7 col-md-7">

                <div class="card mb-4 hmcard">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <h5 class="card-title flex-grow-1 mb-0">
                                <span id="fsttitle">
                                    <template v-if="dashboardTarget === 'po'">Purchase Order</template>
                                    <template v-else-if="dashboardTarget === 'quote'">Quotation</template>
                                    <template v-else>Sales</template>
                                </span> Statistics</h5>
                            <div class="flex-shrink-0 mt-2 mt-sm-0 d-flex">
                                <div class="me-2">
                                    <select class="form-select" v-model="dashboardTarget"
                                            style="min-width: 120px;height: 32px;line-height: .9;">
                                        <option value="so">Sales Order</option>
                                        <option value="po">Purchase Order</option>
                                        <option value="quote">Quotation</option>
                                    </select>
                                </div>
                                <div class="input-group">
                                    <!--<span class="input-group-text px-2"
                                          style="height: 32px;"><i class="ri-calendar-2-line"></i></span>
                                    <input class="form-control" id="reportrange" type="text"
                                           placeholder="Select Date Range" data-input style="height: 32px;">
                                    <date-range-picker
                                        :autoApply="autoApply"
                                        :singleDatePicker="singleDatePicker"
                                        v-model="dateRange"
                                        @update="updateValues"
                                    ></date-range-picker>-->
                                    <date-range-picker
                                        ref="picker"
                                        :always-show-calendars="false"
                                        :autoApply="chartDateOptions.autoApply"
                                        :locale-data="{ firstDay: 1, format: 'mm-dd-yyyy', customRangeLabel: 'Custom', }"
                                        :startDate="chartDateOptions.startDate"
                                        :endDate="chartDateOptions.endDate"
                                        :ranges="chartDateOptions.ranges"
                                        v-model="dateRange"
                                        @update="updateValues"
                                        @toggle="logEvent('event: open', $event)"
                                        @start-selection="logEvent('event: startSelection', $event)"
                                        @finish-selection="logEvent('event: finishSelection', $event)"
                                    >
                                    </date-range-picker>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pb-1" style="position: relative;" v-if="chartsLoaded">
                        <div id="sales" class="graph Sales" v-if="dashboardTarget === 'so' && soChartOptions.series.length">
                            <apexchart height="355px" type="line" :options="soChartOptions" :series="soChartOptions.series"></apexchart>
                        </div>
                        <div id="purchase" class="graph Sales" v-if="dashboardTarget === 'po' && poChartOptions.series.length">
                            <apexchart height="355px" type="line" :options="poChartOptions" :series="poChartOptions.series"></apexchart>
                        </div>
                        <div id="quote" class="graph Sales" v-if="dashboardTarget === 'quote' && chartOptions.series.length">
                            <apexchart height="355px" type="line" :options="chartOptions" :series="chartOptions.series"></apexchart>
                        </div>
                    </div>
                </div>

                <!--<div class="card mb-4 hmcard">
                  <div class="card-header">
                      <div class="d-md-flex align-items-center">
                          <h5 class="card-title flex-grow-1 mb-0"><span id="fsttitle">Sales</span> Statistics</h5>
                          <div class="flex-shrink-0 mt-2 mt-sm-0 d-flex">
                              <div class="me-2">
                                  <select class="form-select" id="fstselect" style="min-width: 120px;height: 32px;line-height: .9;">
                                      <option value="Sales">Sales</option>
                                      <option value="Purchase">Purchase</option>
                                  </select>
                              </div>
                              <div class="input-group">
                                  <span class="input-group-text px-2" id="inputGroup-sizing-default" style="height: 32px;"><i class="ri-calendar-2-line"></i></span>
                                  <input class="form-control" id="reportrange" type="text" placeholder="Select Date Range" data-input style="height: 32px;">
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card-body pb-1" style="position: relative;">
                      <div class="chart-table">

                            <template>
                            <div id="chart">
                               <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
                            </div>
                            </template>
                            </div>
                  </div>
              </div>--><!--end card-->


            </div>
            <div class="col-lg-5 col-md-5">
                <div class="card mb-4 hmcard">
                    <div class="card-header">
                        <div class="d-sm-flex align-items-center">
                            <h5 class="card-title flex-grow-1 mb-0">
                                <span id="sndtitle">
                                    <template v-if="dashboardTargetUser == 'vendor'">
                                    Vendor
                                </template>
                                    <template v-else>
                                    Customer
                                </template>
                                    </span>
                                <template v-if="dashboardTarget == 'quote'">
                                    Quotes
                                </template>
                                <template v-else-if="dashboardTarget == 'po'">
                                    Purchase Orders
                                </template>
                                <template v-else>
                                    Orders
                                </template>
                            </h5>
                            <div class="flex-shrink-0 mt-2 mt-sm-0 d-flex">
                                <div class="me-2">
                                    <select class="form-select" id="sndselect" v-model="dashboardTargetUser"
                                            style="min-width: 125px;height: 32px;line-height: .9;">
                                        <option value="customer">Customer</option>
                                        <option value="vendor">Vendor</option>
                                    </select>
                                </div>
                                <!-- <div class="input-group">

                                    <span class="input-group-text px-2" id="inputGroup-sizing-default"
                                          style="height: 32px;"><i class="ri-calendar-2-line"></i></span>
                                    <flat-pickr  data-input v-model="user_date" class="form-control dates flatpickr-input"
                                                :config="flatPickerConfig"
                                                 style="height: 32px;max-width: 135px; background-color: white !important;"
                                                placeholder="Select date"></flat-pickr>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive table-card cngtable Customer" id="customers" data-simplebar
                             style="max-height: 390px;" v-if="dashboardTargetUser == 'customer'">
                            <table class="table table-bordered table-nowrap align-middle mb-0 sm-row">
                                <thead class="table-light text-muted">
                                <tr>
                                    <th scope="col">Customers</th>
                                    <th scope="col">
                                        <template v-if="dashboardTarget == 'quote'">
                                            Quotes
                                        </template>
                                        <template v-else-if="dashboardTarget == 'po'">
                                            Purchase Orders
                                        </template>
                                        <template v-else>
                                            Orders
                                        </template>
                                    </th>
                                    <th scope="col" v-if="dashboardTarget != 'quote'">Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(customer, index) in customers">
                                    <td>
                                        <!--<img :src="asset('/assets/images/users/no-image.png')" alt=""
                                             class="avatar-xs rounded-circle me-2">-->

                                        <a href="javascript:void(0)" class="text-body fw-medium"
                                           @click="gotoCustomerTargetList(customer.id, 'customer')">{{customer.company_name}}</a>
                                    </td>
                                    <td>
                                        <template v-if="dashboardTarget == 'quote'">{{customer.customer_quotations_count}}</template>
                                        <template v-if="dashboardTarget == 'po'">{{customer.customer_purchase_orders_count}}</template>
                                        <template v-if="dashboardTarget == 'so'">{{customer.customer_order_count}}</template>
                                    </td>
                                    <td v-if="dashboardTarget != 'quote'">
                                        <template v-if="dashboardTarget == 'po'">${{getSumSalesOrdersPrice(customer.customer_purchase_orders)}}</template>
                                        <template v-if="dashboardTarget == 'so'">${{getSumSalesOrdersPrice(customer.customer_order)}}</template>

                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive table-card cngtable Customer" id="vendors" data-simplebar
                             style="max-height: 390px;" v-if="dashboardTargetUser == 'vendor'">
                            <table class="table table-bordered table-nowrap align-middle mb-0 sm-row">
                                <thead class="table-light text-muted">
                                <tr>
                                    <th scope="col">Vendors</th>
                                    <th scope="col">
                                        <template v-if="dashboardTarget == 'quote'">
                                            Quotes
                                        </template>
                                        <template v-else-if="dashboardTarget == 'po'">
                                            Purchase Orders
                                        </template>
                                        <template v-else>
                                            Orders
                                        </template>
                                    </th>
                                    <th scope="col" v-if="dashboardTarget != 'quote'">Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(vendor, index) in vendors">
                                    <td>
                                        <!--<img :src="asset('/assets/images/users/no-image.png')" alt=""
                                             class="avatar-xs rounded-circle me-2">-->
                                        <a href="javascript:void(0)" class="text-body fw-medium"
                                           @click="gotoVendorTargetList(vendor.id, 'vendor')">{{vendor.company_name}}</a>
                                    </td>
                                    <td>
                                        <template v-if="dashboardTarget == 'quote'">{{vendor.vendor_quotations_count}}</template>
                                        <template v-if="dashboardTarget == 'po'">{{vendor.vendor_purchase_orders_count}}</template>
                                        <template v-if="dashboardTarget == 'so'">{{vendor.vendor_orders_count}}</template>
                                    </td>
                                    <td v-if="dashboardTarget != 'quote'">
                                        <template v-if="dashboardTarget == 'po'">${{getSumSalesOrdersPrice(vendor.vendor_purchase_orders)}}</template>
                                        <template v-if="dashboardTarget == 'so'">${{getSumSalesOrdersPrice(vendor.vendor_orders)}}</template>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!--<div class="card panel shadow-sm">
                    <div class="card-body pb-0">
                        <h4 class="card-title mb-2">Customers</h4>
                        <div class="chat-h chat-container">
                            <div class="table-responsive borderless hmcard">
                                <table class="table table-centered table-hover mb-0">
                                    <thead>

                                    <tr>
                                        <th class="border-top-0">Customer
                                            Name
                                        </th>
                                        <th class="border-top-0 text-center">
                                            Quotes
                                        </th>
                                    </tr>

                                    </thead>
                                    <tbody id="old_topuser">
                                        <template v-for="(customer, index) in allData.customer_data">
                                        <tr>
                                        <td>
                                            <span class="ml-1">
                                                <a href="javascript:void(0)" @click="gotoCustomerTargetList(customer.id, 'customer')">{{customer.company_name}}</a>
                                            </span>
                                        </td>
                                        <td class="text-center">{{customer.customer_quotations_count}}</td>
                                        </tr>
                                        </template>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>-->

            </div>
        </div>


        <div class="row">
            <div class="col-md-7">

                <div class="card mb-3 hmcard">
                    <div class="card-header">
                        <div class="d-flex align-items-center">
                            <h5 class="card-title flex-grow-1 mb-0">Tasks</h5>
                            <div class="flex-shrink-0 mt-2 mt-sm-0">
                                <a v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-task')" href="javascript:void(0)" class="btn btn-primary" data-toggle="modal"
                                   data-target="#addTaskModal" style="height: 30px;line-height: .9;">Add Task</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive task-table table-card" data-simplebar style="max-height: 300px;">
                            <table class="table table-bordered table-nowrap align-middle mb-0 sm-row">
                                <thead class="table-light text-muted">
                                <tr>
                                    <th class="ade" scope="col">Order Number</th>
                                    <th class="ade" scope="col">Task</th>
                                    <th class="ade" scope="col">Customer/Vendor</th>
                                    <th class="ade" scope="col">Assigned To</th>
                                    <th class="ade" scope="col">Due On</th>
                                    <th class="ade" scope="col">Priority</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="tasks && tasks.data && tasks.data.length">
                                    <tr v-for="(task, index) in tasks.data">
                                        <td class="fw-medium">
                                            <template
                                                v-if="task.taskable_type === 'App\\Models\\Order' && task.taskable">
                                                <router-link
                                                    :to="{ name: 'orderShow', params: { id: task.taskable.id }}"
                                                    href="javascript:void(0)">#{{ task.taskable.order_number }}
                                                </router-link>
                                            </template>
                                            <template
                                                v-if="task.taskable_type === 'App\\Models\\PurchaseOrder' && task.taskable">
                                                <router-link
                                                    :to="{ name: 'purchaseOrderShow', params: { id: task.taskable.id }}"
                                                    href="javascript:void(0)">#{{ task.taskable.po_number }}
                                                </router-link>
                                            </template>

                                        </td>
                                        <td class="fw-medium">
                                            <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin')">
                                                <a href="javascript:void(0)" @click="editTask(task)">{{ task.title }}</a>
                                            </template>
                                            <template v-else>{{ task.title }}</template>
                                        </td>
                                        <td>
                                            <template v-if="task.taskable && task.taskable.customer">
                                                <template
                                                    v-if="task.taskable_type === 'App\\Models\\Order' && task.taskable">
                                                    <!--<img :src="asset('/assets/images/users/no-image.png')" alt="" class="avatar-xs rounded-circle me-2">-->
                                                    <router-link
                                                        :to="{name: 'customerDetails', params:{id: task.taskable.customer.id}}"
                                                        class="text-body fw-medium">
                                                        {{ task.taskable.customer.company_name }}
                                                    </router-link>
                                                </template>
                                                <template
                                                    v-if="task.taskable_type === 'App\\Models\\PurchaseOrder' && task.taskable">
                                                    <!--<img :src="asset('/assets/images/users/no-image.png')" alt="" class="avatar-xs rounded-circle me-2">-->
                                                    <router-link
                                                        :to="{name: 'vendorDetails', params:{id: task.taskable.customer.id}}"
                                                        class="text-body fw-medium">
                                                        {{ task.taskable.customer.company_name }}
                                                    </router-link>
                                                </template>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-for="(admin, adminIndex) in task.admins">
                                                <template v-if="adminIndex > 0">,</template>
                                                {{ admin.name }}
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="task.status == 1">
                                                Completed at {{ formatDate(task.completed_at) }}
                                            </template>
                                            <template v-else>
                                                {{ formatDate(task.due_date) }} <span
                                                :class="getTimeAgoClass(task.due_date)">{{ getTimeAgo(task.due_date) }}</span>
                                            </template>
                                        </td>
                                        <td><span class="badge"
                                                  :class="nameToCSSClass(task.priority.priority_name, 'badge-soft-')"
                                                  v-if="task.priority">{{ task.priority.priority_name }}</span></td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="6" style="padding: 0.75rem 0.85rem;">No records found!</td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div><!--end card-->
            </div>

            <div class="col-md-5">
                <div class="card mb-3 hmcard">
                    <div class="card-header">
                        <div class="d-flex align-items-center">
                            <h5 class="card-title flex-grow-1 mb-0">Reminders</h5>
                            <div class="flex-shrink-0 mt-2 mt-sm-0">
                                <a href="javascript:void(0)" class="btn btn-primary" data-toggle="modal"
                                   data-target="#addReminderModal" style="height: 30px;line-height: .9;">Add
                                    Reminder</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive task-table2 table-card" data-simplebar style="max-height: 300px;">
                            <table class="table table-bordered table-nowrap align-middle customtablenew mb-0">
                                <thead class="table-light text-muted">
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Assigned To</th>
                                    <th scope="col">Due On</th>
                                    <th scope="col">Priority</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-if="reminders && reminders.data && reminders.data.length">
                                    <tr v-for="(reminder, index) in reminders.data">
                                        <td class="fw-medium">
                                            <a href="javascript:void(0)"
                                               @click="viewReminder(reminder)">{{ reminder.title }}</a>
                                        </td>
                                        <td>
                                            <template v-for="(admin, adminIndex) in reminder.admins">
                                                <template v-if="adminIndex > 0">,</template>
                                                {{ admin.name }}
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="reminder.status == 1">
                                                Completed at {{ formatDate(reminder.completed_at) }}
                                            </template>
                                            <template v-else>
                                                {{ formatDate(reminder.due_date) }} <span
                                                :class="getTimeAgoClass(reminder.due_date)">{{ getTimeAgo(reminder.due_date) }}</span>
                                            </template>
                                        </td>
                                        <td><span class="badge"
                                                  :class="nameToCSSClass(reminder.priority.priority_name, 'badge-soft-')"
                                                  v-if="reminder.priority">{{ reminder.priority.priority_name }}</span>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="4">No records found!</td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div><!--end card-->
            </div>
        </div>

        <!--<date-range-picker
            ref="picker"
            :opens="'center'"
            :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
            :minDate="chartDateOptions.minDate" :maxDate="chartDateOptions.maxDate"
            :singleDatePicker="chartDateOptions.singleDatePicker"
            :timePicker="chartDateOptions.timePicker"
            :timePicker24Hour="chartDateOptions.timePicker24Hour"
            :showWeekNumbers="chartDateOptions.showWeekNumbers"
            :showDropdowns="chartDateOptions.showDropdowns"
            :autoApply="chartDateOptions.autoApply"
            v-model="dateRange"
            @update="updateDateRangeValues"
            @toggle="logEvent('event: open', $event)"
            @start-selection="logEvent('event: startSelection', $event)"
            @finish-selection="logEvent('event: finishSelection', $event)"
            :dateFormat="dateFormat"
        >
            <template v-slot:input="picker" style="min-width: 350px;">
                {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
        </date-range-picker>-->



        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-sm-end d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <AddTask :task="task" @addedEvent="taskAddedEvent" @updatedEvent="taskUpdatedEvent"></AddTask>
        <AddReminder :reminder="reminder" :quotation="null" :user="getAuthUser" @addedEvent="reminderAddedEvent"
                     @updatedEvent="reminderUpdatedEvent"></AddReminder>
        <ViewReminder :reminder="reminder" :quotation="null" @openEditEvent="editReminder" @reminderCompletedEvent="reminderCompletedEvent"></ViewReminder>
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import moment from 'moment';
import AddTask from "../../components/AddTask";
import AddReminder from "../../components/AddReminder";
import DatePicker from "vue2-datepicker";
import ViewReminder from "../../components/ViewReminder";

export default {
    name: "Dashboard",
    components: {AddReminder, carousel, AddTask, DatePicker, ViewReminder},
    created() {
        if (localStorage.getItem('token')) {
            //console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
    },
    mounted() {
        let self = this;
        $('#addTaskModal').on('hidden.bs.modal', function () {
            self.task = null;
        });
        if(this.getDashboardTarget) {
            this.dashboardTarget = this.getDashboardTarget;
        }
        if(this.getDashboardTargetUser) {
            this.dashboardTargetUser = this.getDashboardTargetUser;
        }
        this.getDashboard();
        this.getCharts();
        this.getUsers();
        this.getTasks();
        this.getReminders();

        /*$('#reportrange').daterangepicker({
            startDate: self.chartDateOptions.startDate,
            endDate: self.chartDateOptions.endDate,
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        }, self.dateRangePickerCB);

        self.dateRangePickerCB(self.chartDateOptions.startDate, self.chartDateOptions.endDate);*/

        //$("#user_date_id").flatpickr();
        //$(".dates").flatpickr();
        //flatpickr("#user_date_id", {});

    },
    data() {
        return {
            flatPickerConfig: {
                wrap: false, // set wrap to true only when using 'input-group'
                altFormat: 'm-d-Y',
                altInput: false,
                dateFormat: 'm-d-Y',
                //locale: Hindi, // locale for this instance only
            },
            dashboardTarget: 'so',
            dashboardTargetUser: 'customer',
            inlineDatePicker: true,
            autoApply: true,
            singleDatePicker: false,
            showDropdowns: true,
            // dateRange: {startDate, endDate},
            inlineDateRange: {
                startDate: moment().subtract(29, 'days').toDate(),
                endDate: moment().toDate(),
                ranges: false
            },
            dateRange1: {
                startDate: moment().subtract(29, 'days').toDate(),
                endDate: moment().toDate(),
            },
            dateRange: {
                startDate: moment().subtract(29, 'days').toDate(),
                endDate: moment().toDate(),
                ranges: {
                    'Today': [moment().toDate(), moment().toDate()],
                    'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                    'Last 7 Days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                    'Last 30 Days': [moment().subtract(29, 'days').toDate(), moment().toDate()],
                    'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
                    'Last Month': [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()]
                },
            },
            allData: {
                'quote_count': [],
                'notify': null,
                'desktop_notification': null,
                'start_time': null,
                'end_time': null,
                'top_ten': [],
                'customer_data': [],
                'users': [],
                'users_quote_count': null,
                'count': null,
                'quotations_data': [],
                'quotes': [],
                orderData: {
                    total_todo: 0,
                    total_reminder: 0,
                    order_open: 0,
                    order_sent_customer: 0,
                    order_artwork_approval: 0,
                    order_in_production: 0,
                    order_shipped: 0,
                }
            },
            date: '',
            chartuser: [],
            chartuserXaxis: [],
            chartuserFirstTd: [],
            chartuserLastTd: [],
            filterForm: {
                search_filter: null,
                status_filter: null,
                start: moment().subtract(29, 'days').format('DD-MM-YYYY'),
                end: moment().format('DD-MM-YYYY'),
              //  startDate: moment().subtract(29, 'days').toDate(),
                //endDate: moment().toDate(),
                //start:"02-11-2021",
                //end:"01-12-2021",
            },
            mainchart: [],
            processingUpload: false,
            series: [{
                name: 'Total Quotes',
                data: []
            }],
            userSeries: [],
            chartsLoaded: false,
            chartOptions: {
                series: [],
                chart: {
                    height: 355,
                    type: "line",
                    toolbar: {
                        show: false,
                    },
                },
                stroke: {
                    curve: "straight",
                    dashArray: [0, 0],
                    width: [2, 0],
                },
                fill: {
                    opacity: [0.1, 0.9],
                },
                markers: {
                    size: [0, 0],
                    strokeWidth: 2,
                    hover: {
                        size: 4,
                    },
                },
                xaxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                    ],
                    axisTicks: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                },
                yaxis: {
                    //tickAmount: 2,
                    min: 0,
                    max: function(value) {
                        //console.log(value)
                        return value < 30 ? 30 : value
                    },
                    //forceNiceScale: true,
                    showAlways: true,
                    decimalsInFloat: 2
                },
                grid: {
                    show: true,
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                    padding: {
                        top: 0,
                        right: -2,
                        bottom: 15,
                        left: 10,
                    },
                },
                legend: {
                    show: true,
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: -5,
                    markers: {
                        width: 9,
                        height: 9,
                        radius: 6,
                    },
                    itemMargin: {
                        horizontal: 10,
                        vertical: 0,
                    },
                },
                plotOptions: {
                    bar: {
                        columnWidth: "30%",
                        barHeight: "70%",
                    },
                },
                colors: ['#0ab39c', '#405189'],
                tooltip: {
                    shared: true,
                    y: [{
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return y.toFixed(0);
                            }
                            return y;
                        },
                    }
                    ],
                },
                noData: {
                    text: 'Loading...'
                }
            },

            soChartOptions: {
                series: [],
                chart: {
                    height: 355,
                    type: "line",
                    toolbar: {
                        show: false,
                    },
                },
                stroke: {
                    curve: "straight",
                    dashArray: [0, 0],
                    width: [2, 0],
                },
                fill: {
                    opacity: [0.1, 0.9],
                },
                markers: {
                    size: [0, 0],
                    strokeWidth: 2,
                    hover: {
                        size: 4,
                    },
                },
                xaxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                    ],
                    axisTicks: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                },
                yaxis: {
                    //tickAmount: 2,
                    min: 0,
                    max: function(value) {
                        //console.log(value)
                        return value < 30 ? 30 : value
                    },
                    //forceNiceScale: true,
                    showAlways: true,
                    decimalsInFloat: 2,
                    syncWithAxis: true
                },
                grid: {
                    show: true,
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                    padding: {
                        top: 0,
                        right: -2,
                        bottom: 15,
                        left: 10,
                    },
                },
                legend: {
                    show: true,
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: -5,
                    markers: {
                        width: 9,
                        height: 9,
                        radius: 6,
                    },
                    itemMargin: {
                        horizontal: 10,
                        vertical: 0,
                    },
                },
                plotOptions: {
                    bar: {
                        columnWidth: "30%",
                        barHeight: "70%",
                    },
                },
                colors: ['#0ab39c', '#405189'],
                tooltip: {
                    shared: true,
                    y: [{
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return "$" + y.toFixed(0) + "k";
                            }
                            return y;
                        },
                    }
                    ],
                },
                noData: {
                    text: 'Loading...'
                }
            },
            poChartOptions: {
                series: [],
                chart: {
                    height: 355,
                    type: "line",
                    toolbar: {
                        show: false,
                    },
                },
                stroke: {
                    curve: "straight",
                    dashArray: [0, 0],
                    width: [2, 0],
                },
                fill: {
                    opacity: [0.1, 0.9],
                },
                markers: {
                    size: [0, 0],
                    strokeWidth: 2,
                    hover: {
                        size: 4,
                    },
                },
                xaxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                    ],
                    axisTicks: {
                        show: false,
                    },
                    axisBorder: {
                        show: false,
                    },
                },
                yaxis: {
                    //tickAmount: 2,
                    min: 0,
                    max: function(value) {
                        //console.log(value)
                        return value < 30 ? 30 : value
                    },
                    //forceNiceScale: true,
                    showAlways: true,
                    decimalsInFloat: 2,
                    syncWithAxis: true
                },
                grid: {
                    show: true,
                    xaxis: {
                        lines: {
                            show: true,
                        },
                    },
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                    padding: {
                        top: 0,
                        right: -2,
                        bottom: 15,
                        left: 10,
                    },
                },
                legend: {
                    show: true,
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: -5,
                    markers: {
                        width: 9,
                        height: 9,
                        radius: 6,
                    },
                    itemMargin: {
                        horizontal: 10,
                        vertical: 0,
                    },
                },
                plotOptions: {
                    bar: {
                        columnWidth: "30%",
                        barHeight: "70%",
                    },
                },
                colors: ['#0ab39c', '#405189'],
                tooltip: {
                    shared: true,
                    y: [{
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return "$" + y.toFixed(0) + "k";
                            }
                            return y;
                        },
                    }
                    ],
                },
                noData: {
                    text: 'Loading...'
                }
            },

            tasks: null,
            reminders: null,
            reminderFilter: {
                user_id: null
            },
            task: null,
            reminder: null,
            admins: [],
            customers: [],
            vendors: [],
            user_date: null,
            chartDateOptions: {
                startDate:  moment().subtract(29, 'days'),
                endDate: moment(),
                minDate:  moment().subtract(20, 'years'),
                maxDate: moment().add(20, 'years'),
                singleDatePicker: false,
                timePicker: false,
                timePicker24Hour: false,
                showWeekNumbers: false,
                showDropdowns: false,
                autoApply: true,
                ranges: {
                    'Today': [moment().toDate(), moment().toDate()],
                    'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                    'Last 7 Days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                    'Last 30 Days': [moment().subtract(29, 'days').toDate(), moment().toDate()],
                    'This Month': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
                    'Last Month': [moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate()],
                    //'This Year': [moment().startOf('year').toDate(), moment().endOf('year').toDate()]
                },

            }

        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading',
            'setLoading',
            'setDashboardTarget',
            'setDashboardTargetUser',
            'setOrdersFilterData',
            'setOrdersShowFilters',
            'setPurchaseOrdersFilterData',
            'setPurchaseOrdersShowFilters'
        ]),
        dateRangePickerCB(start, end){
            $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        },
        updateDateRangeValues(event){
           // console.log('updateDateRangeValues', event)
        },
        logEvent(type, event){
            //console.log('logEvent', type, event)
        },
        getSumSalesOrdersPrice(orders){
            let total = 0;
            if(orders && orders.length) {
                orders.forEach((x) => {
                    total += x.amount;
                })
            }
            return total;
        },
        getUsers() {

            //console.log("hhhss ",this.filterForm);
            let self = this;

            return axios.post(window.route('dashboard.getUsers'),
                {
                    dashboardTargetUser: this.dashboardTargetUser,
                    dashboardTarget: this.dashboardTarget,
                    start: this.filterForm.start,
                    end: this.filterForm.end,
                    user_date: this.user_date,
                },
                {

                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                }
                )
                .then(({data}) => {
                    //console.log(this.dashboardTargetUser);
                    if(data.success) {
                        //console.log('dashboardTargetUser', data);
                        if(this.dashboardTargetUser === 'vendor') {
                            this.vendors = _.cloneDeep(data.users);
                        } else {
                            this.customers = _.cloneDeep(data.users);
                        }

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        editTask(task) {
            this.task = _.cloneDeep(task);
            setTimeout(() => {
                $('#addTaskModal').modal('show');
            }, 100);
        },
        getTimeAgo(datetime) {
            return this.getTimeAgoObj(datetime).label;
        },
        getTimeAgoClass(datetime) {
            return this.getTimeAgoObj(datetime).class;
        },
        getTimeAgoObj(datetime) {
            //return moment(datetime).fromNow();
            let today = moment();
            let days = moment(datetime).diff(today, 'days');
            if( days > 0 ) {
                return {
                    days: days,
                    label: `+${days}days`,
                    class: 'text-success'
                }
            }

            return {
                days: days,
                label: `${days}days`,
                class: 'text-danger'
            }
        },
        taskAddedEvent(event) {
            this.getTasks();
            $('#addTaskModal').modal('hide');
        },
        taskUpdatedEvent(event) {
            this.task = null;
            this.getTasks();
            $('#addTaskModal').modal('hide');
        },
        getTasks() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.get(window.route('dashboard.tasks.index', {status: 0}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.tasks = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        viewReminder(reminder) {
            this.reminder = _.cloneDeep(reminder);
            setTimeout(() => {
                $('#viewReminderModal').modal('show');
            }, 100);
        },
        editReminder(reminder) {
            this.reminder = _.cloneDeep(reminder);
            $('#viewReminderModal').modal('hide');
            setTimeout(() => {
                $('#addReminderModal').modal('show');
            }, 100);
        },
        reminderAddedEvent(event) {
            this.getReminders();
            $('#addReminderModal').modal('hide');
        },
        reminderUpdatedEvent(event) {
            this.reminder = null;
            this.getReminders();
            $('#addReminderModal').modal('hide');
        },
        reminderCompletedEvent(event) {
            this.getReminders();
        },
        getReminders() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.get(window.route('dashboard.reminders.index', {status: 0, user_id: this.reminderFilter.user_id}), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.reminders = _.cloneDeep(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getReminderSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.get(window.route('dashboard.tasks.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.admins = _.cloneDeep(data.data.admins);
                        //this.priorities = _.cloneDeep(data.data.priorities);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        dateFormat(classes, date) {
            //console.log(classes)
            if (!classes.disabled) {
                classes.disabled = date.getTime() < new Date()
            }
            return classes
        },
        gotoCustomerTargetList(id, type) {
            /*if(this.dashboardTarget === 'quote') {
                localStorage.setItem('q_filter_type', type);
                localStorage.setItem('q_filter_cus_id', id);
                localStorage.setItem('q_filter_start', moment(this.dateRange.startDate).format('DD-MM-YYYY'));
                localStorage.setItem('q_filter_end', moment(this.dateRange.endDate).format('DD-MM-YYYY'));
                console.log("id", id);
                console.log("type", type);
                console.log(moment(this.dateRange.endDate).format('DD-MM-YYYY'));
                this.$router.push({name: 'quotations'});
            } else if(this.dashboardTarget === 'po') {
                let filterData = {
                    purchase_search: null,
                    search_saleuser_id: null,
                    search_vendor_id: null,
                    search_added_user_id: null,
                    search_by_date: null,
                    search_status_Id: null,
                    date_range: null
                };

                this.setPurchaseOrdersFilterData(filterData);
                this.setPurchaseOrdersShowFilters(false);
                this.$router.push({name: 'purchaseOrders'});
            } else {
                let filterData = {
                    search_filter: null,
                    sale_user_id: null,
                    search_customer_id: id,
                    search_added_user_id: null,
                    search_by_date: null,
                    status_search: null,
                    date_range: null
                };

                this.setOrdersFilterData(filterData);
                this.setOrdersShowFilters(false);

                this.$router.push({name: 'orders'});
            }*/

            this.$router.push({name: 'customerDetails', params: {id: id}});

        },
        gotoVendorTargetList(id, type) {
            /*if(this.dashboardTarget === 'quote') {
                this.$router.push({name: 'quotations'});
            } else if(this.dashboardTarget === 'po') {
                let filterData = {
                    purchase_search: null,
                    search_saleuser_id: null,
                    search_vendor_id: id,
                    search_added_user_id: null,
                    search_by_date: null,
                    search_status_Id: null,
                    date_range: null
                };

                this.setPurchaseOrdersFilterData(filterData);
                this.setPurchaseOrdersShowFilters(false);
                this.$router.push({name: 'purchaseOrders'});
            } else {
                this.$router.push({name: 'orders'});
            }*/
            this.$router.push({name: 'vendorDetails', params: {id: id}});

        },
        updateValues(){
            let self = this;

            this.filterForm.start = moment(this.dateRange.startDate).format('DD-MM-YYYY');
            this.filterForm.end = moment(this.dateRange.endDate).format('DD-MM-YYYY');
            //console.log("updateValues",this.filterForm);
            this.getCharts();
            this.getUsers();
            //this.getDashboard();
            //this.updateChart();
            //this.userChart();
            //this.topTenUsers();
            //   console.log("here  selected date ",moment(this.dateRange.startDate).format('YYYY-MM-DD'));
            //   console.log("here  selected date ",moment(this.dateRange.endDate).format('YYYY-MM-DD'));

        },
        getCharts() {
            this.getUsers();
            let self = this;

            return axios.post(window.route('dashboard.getCharts'), {
                dashboardTarget: this.dashboardTarget,
                start: this.filterForm.start,
                end: this.filterForm.end,
            },{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    //console.log(this.dashboardTarget);
                    if(data.success) {
                        //console.log('quotesByMonth', data);
                        if(this.dashboardTarget === 'quote') {
                            this.chartOptions.series = [
                                {
                                    name: "Total Quotes",
                                    type: "area",
                                    data: data.quotesByMonth,
                                }
                            ];
                        } else if(this.dashboardTarget === 'po') {
                            this.poChartOptions.series = [
                                {
                                    name: "Total Amount",
                                    type: "area",
                                    data: data.ordersAmountByMonth.map(x => { const k = x/1000; return `${k}`; }),
                                },
                                {
                                    name: "Orders",
                                    type: "bar",
                                    data: data.ordersByMonth,
                                }
                            ];
                        } else {
                            this.soChartOptions.series = [
                                {
                                    name: "Total Sales",
                                    type: "area",
                                    data: data.ordersAmountByMonth.map(x => { const k = x/1000; return `${k}`; }),
                                },
                                {
                                    name: "Orders",
                                    type: "bar",
                                    data: data.ordersByMonth,
                                }
                            ];
                        }

                        this.chartsLoaded = true;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        updateChart() {
            let self = this;

            return axios.post(window.route('dashboard.quotation_chart'), {

                start: this.filterForm.start,
                end: this.filterForm.end,
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    // console.log(data.mainchart);
                    let seriesData = [];
                    let catData = [];
                    this.allData.count = data.maincount;
                    for (var i = 0; i < data.mainchart.length; i++) {
                        //console.log(data.mainchart[i].date);
                        seriesData.push(data.mainchart[i].count);
                        catData.push(data.mainchart[i].date);

                    }

                    this.series = [{
                        name: 'Quotation',
                        data: seriesData
                    }]

                    //console.log("this.series", this.series);
                    this.chartOptions = {
                        xaxis: {
                            categories: catData
                        }
                    }

                    //console.log("this.chartOptions", this.chartOptions);

                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getDashboard() {

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('dashboard.index', {params: this.filterForm}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    // console.log(data);
                    if (data.errors) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.allData = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() {
            $('#deleteModal').modal('hide');
            this.deleteId = null;
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            //'customers',
            //'customersLoading',
            'getDashboardTarget',
            'getDashboardTargetUser'
            //'allData'
        ])
    },
    watch: {
        dashboardTarget: {
            handler: function (after, before) {
                if(after !== before) {
                    this.setDashboardTarget(after);
                    this.getCharts();
                    this.getUsers();
                }
            }
        },
        dashboardTargetUser: {
            handler: function (after, before) {
                if(after !== before) {
                    this.setDashboardTargetUser(after);
                    this.getUsers();
                }
            }
        },
        user_date: {
            handler: function (after, before) {
                if(after !== before) {
                    this.getUsers();
                }
            }
        }
    }
}


</script>


<style scoped>

</style>
